<template>
  <!-- <Search :placeholder="`${$route.path.split('/')[1]}`" v-if="showSearch" /> -->
  <Search
    :placeholder="placeholder"
    v-if="showSearch"
    :hasButton="hasButton"
    :searchOnSubmit="searchOnSubmit"
    :submitOnEnter="submitOnEnter"
  />
</template>

<script>
export default {
  name: 'SearchAndFilter',
  props: {
    placeholder: {
      type: String,
      required: true,
      default: 'Search ...'
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    searchOnSubmit: {
      type: Boolean,
      default: false
    },
    showDate: {
      type: Boolean,
      default: false
    },
    hasButton: {
      type: Boolean,
      default: true
    },
    submitOnEnter: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Search: () => import('@/components/Universal/Search')
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';
</style>
